import { modelOptions, prop } from '@typegoose/typegoose';

@modelOptions({
  schemaOptions: { collection: 'rawEventsCsvs' },
  options: { customName: 'rawEventsCsvs' },
})
export class RawEventsCsvs {
  @prop({
    expires: 60,
    type: Date,
    index: true,
  })
  insertedAt: Date;
}
